export default __webpack_public_path__ + "images/BbocHero.v-9fc6f223f330c1ccc4fd6efe492018a3.svg";